module.exports = __webpack_public_path__ + "img/why.d35f581d.png";